import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { CustomerForm } from "@/features/customers/components/customer-form";
import { useCustomer } from "@/features/customers/hooks/use-customers";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";

export const Route = createFileRoute("/(app)/dashboard/customers/edit/$id")({
  component: EditCustomerPage,
});

function EditCustomerPage() {
  const { id } = Route.useParams();
  const navigate = useNavigate();
  const { data: customer, isLoading } = useCustomer(id);

  const handleSuccess = () => {
    navigate({ to: "/dashboard/customers" });
  };

  if (isLoading) {
    return (
      <div className="container mx-auto py-6">
        <p>Lädt Kunde...</p>
      </div>
    );
  }

  if (!customer) {
    return (
      <div className="container mx-auto py-6">
        <p>Kunde nicht gefunden</p>
      </div>
    );
  }

  return (
    <div className="container mx-auto py-6 space-y-6">
      <div className="flex items-center gap-4">
        <Button
          variant="ghost"
          size="icon"
          onClick={() => navigate({ to: "/dashboard/customers" })}
        >
          <ArrowLeft className="h-4 w-4" />
        </Button>
        <div>
          <h1 className="text-3xl font-bold tracking-tight">Kunde bearbeiten</h1>
          <p className="text-muted-foreground">
            {customer.customerType === "business" 
              ? customer.companyName 
              : `${customer.firstName} ${customer.lastName}`}
          </p>
        </div>
      </div>

      <CustomerForm customer={customer} onSuccess={handleSuccess} />
    </div>
  );
}
